import { provideDrawer } from '@ui';

export const DRAWER_PROVIDER = provideDrawer({
  top: '4.5rem',
  placement: 'start',
});
